module.exports = __webpack_public_path__ + "img/map-location-marker.3b9530d.svg";